<template>
	<div style="background: #f3f4f7" v-loading.fullscreen.lock="fullscreenLoading">
		<userHeader />
		<fuHeader />
		<div class="bodyWrapper">
			<div class="gudBtns">
				<div class="gudBtnItem gudBack supHove3" @click="$router.back()">
					<img src="@/assets/img/back.svg" alt="" />
					<span>返回</span>
				</div>
			</div>
			<div class="searTab">
				<div class="searTabItem" @click="tabFn(item.type)" :class="tabFlag == item.type ? 'tabActive' : ''" v-for="item in tabArr" :key="item.type">
					<span>{{ item.txt }}</span>
				</div>
			</div>
			<div class="searCont" v-if="!perData.length">
				<el-empty description="暂无信息"></el-empty>
			</div>
			<div class="searCont">
				<div class="searContItem active" @click="decBtn(item)" v-for="(item, index) in perData" :key="index">
					<h2>
						{{ item.title }}
						<div class="infoMyVip infoMyPut" v-if="item.limitsAuthority == 0">
							<i class="el-icon-user-solid"></i>
							<span>普通老师</span>
						</div>
						<div class="infoMyVip" v-if="item.limitsAuthority == 1">
							<img src="@/assets/img/hys.svg" alt="" />
							<span>会员老师</span>
						</div>
						<div class="infoMyIcon" v-if="item.type == 5">
							<img src="@/assets/img/jf.svg" alt="" />
							<span>{{ item.points || 0 }}</span>
						</div>
					</h2>
					<p class="matchedFiles" v-if="matchedFileNames(item)">
						包含文件：{{ matchedFileNames(item) }}
					</p>
					<p>来自：{{ item.type | typeName }} > {{ item.sourceTypeName }}</p>
				</div>
			</div>
			<fenye v-if="perData.length" :total="total" ref="fybox" @dataFn="perList" />
		</div>
		<foot />
	</div>
</template>

<script>
import foot from '@/components/foot/foot';
import userHeader from '@/components/hearder/userHeader';
import fuHeader from '@/components/hearder/fuHeader';
import fenye from '@/components/pubComponents/fenye';
export default {
	name: 'searPage',
	data() {
		return {
			tabFlag: 0,
			perData: [],
			total: 0,
			keywords: '',
			fullscreenLoading: false,
			tabArr: [
				{
					type: 0,
					txt: '全部'
				},
				{
					type: 1,
					txt: '网页资源'
				},
				{
					type: 2,
					txt: '文档资源'
				},
				{
					type: 3,
					txt: '试题资源'
				},
				{
					type: 4,
					txt: '我的试卷'
				},
				{
					type: 5,
					txt: '共享协助'
				},
				{
					type: 6,
					txt: '常用工具'
				}
			] // 0全部 1网页资源 2文档资源 3试题资源 4我的试卷 5共享协助 6常用工具
		};
	},
	filters: {
		typeName(val) {
			if (val == 1) {
				return '网页资源';
			} else if (val == 2) {
				return '文档资源';
			} else if (val == 3) {
				return '试题资源';
			} else if (val == 4) {
				return '我的试卷';
			} else if (val == 5) {
				return '共享协助';
			} else if (val == 6) {
				return '常用工具';
			}
		}
	},
	components: {
		userHeader,
		foot,
		fenye,
		fuHeader
	},
	beforeDestroy() {
		// 确保在组件销毁前移除事件监听器
		this.$bus.$off('someEvent');
	},
	methods: {
		matchedFileNames(item) {
			if (!item || !item.matchedFileNames) {
				return '';
			}
			const names = item.matchedFileNames
				.split('|||')
				.map((name) => name.trim())
				.filter((name, index, list) => name && list.indexOf(name) === index);
			if (!names.length) {
				return '';
			}
			return names.slice(0, 3).join('、') + (names.length > 3 ? '……' : '');
		},
		decBtn(item) {
			console.log(item, 999999);
			if (item.type == 1) {
				// 网页资源
				if (item.sourceType == 4) {
					this.$router.push({
						path: './scDec',
						query: {
							type: 4,
							txt: item.sourceTypeName,
							webpageResourceId: item.id,
							crumFlag: 1,
							tabFtxt: ['首页', '电影列表']
						}
					});
				} else {
					this.$router.push({
						path: 'scDec',
						query: {
							type: item.sourceType,
							txt: item.sourceTypeName,
							webpageResourceId: item.id,
							crumFlag: 1,
							tabFtxt: ['首页', '电影列表']
						}
					});
				}
			} else if (item.type == 2) {
				// 1 同步课件 2 最新试卷 3 优质课件 4 荐阅外刊 5 双语节目 6 英语小说 7 优质课 8 双语新闻
				let a = ['首页'];
				if (item.sourceType == 1) {
					a.push('同步课件');
				} else if (item.sourceType == 2) {
					a.push('最新试卷');
				} else if (item.sourceType == 3) {
					a.push('优质课件');
				} else if (item.sourceType == 4) {
					a.push('荐阅外刊');
				} else if (item.sourceType == 5) {
					a.push('双语节目');
				} else if (item.sourceType == 6) {
					a.push('英语小说');
				} else if (item.sourceType == 7) {
					a.push('优质课');
				}
				if (item.sourceType == 9) {
					this.$router.push({
						path: './mqDec',
						query: {
							type: 1,
							txt: item.sourceTypeName,
							coursewarePeriodId: item.id,
							crumFlag: 1,
							tabFtxt: ['首页', '每期课件']
						}
					});
				} else if (item.sourceType == 8) {
					this.$router.push({
						path: 'scDec',
						query: {
							type: 2,
							flags: 1,
							txt: item.title,
							documentResourceId: item.id,
							crumFlag: 1,
							tabFtxt: ['首页', '双语新闻']
						}
					});
				} else {
					this.$router.push({
						path: './hbDec',
						query: {
							type: 5,
							flags: 1,
							conTxt: 1,
							classType: item.sourceType,
							txt: item.title,
							documentResourceId: item.id,
							yzType: '1',
							crumFlag: 1,
							tabFtxt: a
						}
					});
				}
			} else if (item.type == 3) {
				// 试题资源 1书本（听力课本？不让点详情）2每日一听 3高考真题 4课本词汇
				if (item.sourceType == 1) {
					// 听力课本
				} else if (item.sourceType == 2) {
					// 每日一听
					this.$router.push({
						path: './timDec',
						query: {
							type: 1,
							txt: item.title,
							listenEveryDayId: item.id,
							crumFlag: 1,
							tabFtxt: ['首页', '每日一听']
						}
					});
				} else if (item.sourceType == 3) {
					// 3高考真题
					this.$router.push({
						path: './timDec',
						query: {
							type: 1,
							txt: item.title,
							collegeExaminationId: item.id,
							crumFlag: 1,
							tabFtxt: ['首页', '高考真题']
						}
					});
				} else if (item.sourceType == 4) {
					// 4课本词汇
					this.$router.push({
						path: './zystHome',
						query: {
							type: 1,
							tabFtxt: '搜索页',
							tabFlag: 2
						}
					});
				}
			} else if (item.type == 4) {
				// 我的试卷
				this.$router.push({
					path: './timDec',
					query: {
						type: 1,
						types: 'zt',
						txt: item.title,
						groupExamId: item.id,
						crumFlag: 1,
						tabFtxt: ['首页', '我的试卷']
					}
				});
			} else if (item.type == 5) {
				// 共享协助
				this.$router.push({
					path: './hbDec',
					query: {
						type: 5,
						flags: 1,
						txt: item.title,
						mutualAidResourceId: item.id,
						yzType: '',
						crumFlag: 1,
						tabFtxt: ['首页', '互助共享']
					}
				});
			} else if (item.type == 6) {
				// 常用工具
				this.$router.push({
					path: './hbDec',
					query: {
						conTxt: 1,
						txt: item.title,
						toolResourceId: item.id,
						yzType: '1',
						type: 6,
						flags: '',
						crumFlag: 1,
						tabFtxt: ['首页', '常用工具']
					}
				});
			}
		},
		tabFn(type) {
			this.tabFlag = type;
			this.perList({
				pageNum: 1,
				pageSize: 10
			});
		},
		perList(data) {
			let pre = '';
			if (data) {
				pre = {
					pageNum: data.pageNum,
					pageSize: this.$refs['fybox']?.pageSize || 10
				};
			} else {
				pre = {
					pageNum: this.$refs['fybox']?.pageNum,
					pageSize: this.$refs['fybox']?.pageSize
				};
			}
			this.fullscreenLoading = true;
			this.$http
				.post('api/app/yydSearchRecords/search', {
					keywords: this.keywords,
					type: this.tabFlag,
					...pre
				})
				.then((res) => {
					this.fullscreenLoading = false;
					if (res.code == 200) {
						this.perData = res.rows || [];
						this.total = res.total;
					}
				});
		}
	},
	mounted() {
		// 使用 $bus 监听（接收）一个事件
		this.$bus.$on('someEvent', (data) => {
			this.keywords = data;
			this.perList({
				pageNum: 1,
				pageSize: 10
			});
			console.log('Event received with data:', data);
		});
		let { word } = this.$route.query;
		this.keywords = word || '';
		this.perList({
			pageNum: 1,
			pageSize: 10
		});
	}
};
</script>
<style lang="scss" scoped>
.searTab {
	width: 1200px;
	margin: 10px auto 0;
	background: #ffffff;
	border-radius: 6px 6px 0px 0px;
	display: flex;
	box-sizing: border-box;
	padding: 0 9px;
	height: 50px;
	border-bottom: 1px solid #f3f4f7;

	.searTabItem {
		padding: 0 30px;
		font-size: 14px;
		color: #a1a1a1;
		display: flex;
		align-items: center;
		cursor: pointer;
	}
	.tabActive {
		font-weight: bold;
		color: #000;
	}
}
.searCont {
	padding: 0 15px;
	width: 1200px;
	margin: 0 auto;
	box-sizing: border-box;
	background: #fff;
	min-height: 300px;
	.searContItem {
		padding: 15px 0 18px;
		border-bottom: 1px solid #f3f4f7;
		cursor: pointer;
		&:hover {
			h2 {
				color: #1d7b3a;
			}
			p {
				color: #1d7b3a;
			}
		}
		&:last-of-type {
			border: none;
		}

		h2 {
			color: #000000;
			font-size: 14px;
			margin-bottom: 10px;
			display: flex;
			align-items: center;
			.infoMyIcon {
				display: flex;
				align-items: center;
				color: #93571c;
				font-size: 12px;
				margin-left: 14px;
				img {
					width: 14px;
					height: 14px;
					margin-right: 4px;
				}
			}
			.infoMyVip {
				display: flex;
				justify-content: center;
				align-items: center;
				width: 82px;
				height: 23px;
				background: linear-gradient(90deg, #fde6d1 0%, #fdd7b3 100%);
				border-radius: 4px;
				color: #93571c;
				font-size: 12px;
				margin-left: 11px;
				img {
					width: 17px;
					height: 17px;
					margin-right: 4px;
				}
			}
			.infoMyPut {
				background: linear-gradient(90deg, rgba(97, 161, 255, 0.22) 0%, rgba(0, 118, 255, 0.31) 100%);
				color: #0c7bfd;
				i {
					font-size: 14px;
					margin-right: 4px;
					line-height: 1.2;
				}
			}
		}
		p {
			color: #a1a1a1;
			font-size: 12px;
		}
		.matchedFiles {
			color: #666;
			margin-bottom: 8px;
			line-height: 20px;
		}
	}
}
</style>
